<!-- 保证金 -->
<template>
  <div class="container" :style="{ '--color': themeColor }">
    <div class="box">
      <p class="p1">平台保证金</p>
      <div style="display: flex; align-items: center; margin-bottom: 0.24rem">
        <span style="margin-right: 0.06rem">保证金余额</span>
        <div class="yuan">?</div>
        <span>：</span>
        <span class="span1">0 元</span>
      </div>
      <div style="display: flex; align-items: center; margin-bottom: 0.24rem">
        <span style="margin-right: 0.06rem">保证金额度</span>
        <div class="yuan">?</div>
        <span>：</span>
        <span class="span1">0 元</span>
      </div>
    </div>
    <div class="center">
      <span>交易时间：</span>
      <el-date-picker
        size="small"
        style="margin-right: 0.24rem"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
         range-separator="~"
      >
      </el-date-picker>
      <el-button size="small" type="primary">查询</el-button>
      <el-button size="small" type="primary">下载</el-button>
    </div>
    <div class="footer">
      <div
        @click="current = item"
        :class="current === item ? 'active' : ''"
        v-for="(item, index) in btnList"
        :key="index"
        class="btns"
      >
        {{ item }}
      </div>
    </div>
    <el-table
      border
      header-align="center"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column align="center" prop="date" label="交易时间">
      </el-table-column>
      <el-table-column align="center" prop="name" label="订单时间">
        <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatHms }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="orderNumber" label="订单编号">
      </el-table-column>
      <el-table-column align="center" prop="address" label="金额">
        <template slot-scope="scope">
            {{ scope.row.price + '¥' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="address" label="类型">
      </el-table-column>
      <el-table-column align="center" prop="address" label="操作">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props:{
    tableData:{
      type:Array,
      default:[]
    },
  },
  data() {
    return {
      btnList: ["全部", "缴纳", "追加", "扣款", "补缴", "退款"],
      current: "全部",
    };
  },
  computed: {
    ...mapState(["themeColor"]),
  },
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.container {
  .active {
    background-color:var(--color) !important;
    border-color: var(--color) !important;
    color: #fff !important;
  }
  .box {
    width: 5rem;
    height: 2.4rem;
    background-color: #f8f8f8;
    padding: 0.24rem;
    margin-bottom: 0.24rem;
    p {
      margin-bottom: 0.24rem;
    }
    .p1 {
      font-weight: bold;
    }
    .yuan {
      width: 0.2rem;
      height: 0.2rem;
      line-height: 0.2rem;
      border: 1px solid var(--color);
      text-align: center;
      border-radius: 50%;
      color: var(--color);
      font-weight: bold;
    }
    .span1 {
      font-weight: bold;
      font-size: 0.22rem;
      font-weight: 800;
    }
  }
  .center {
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;
  }
  .footer {
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;
    .btns {
      width: 0.8rem;
      height: 0.4rem;
      background-color: #f7f8f8;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #c5c5c5;
      border-left: none;
      color: #a5a1a1;
      cursor: pointer;
      &:nth-child(1) {
        border-left: 1px solid #c5c5c5;
      }
    }
  }
}
</style>
